import { CSSProperties, FC, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HELP_ROUTE } from '../../constants';
import { useArticleSlugsById } from '../../hooks/useArticleSlugsById';
import { ContentfulErrorContext, ContentfulErrorTypes } from '../../hooks/ContentfulErrorContext';

type RelatedArticleTitleProps = {
  articleId: string;
  className?: string;
  style?: CSSProperties;
};

export const RelatedArticleTitle: FC<RelatedArticleTitleProps> = ({ articleId, className, style }) => {
  const { setContentfulErrorType } = useContext(ContentfulErrorContext);

  const { data: article, error, loading } = useArticleSlugsById(articleId);

  useEffect(() => {
    if (error) {
      setContentfulErrorType(ContentfulErrorTypes.Error);
    } else if (!loading && !article) {
      setContentfulErrorType(ContentfulErrorTypes.NoContent);
    }
  }, [error, article, loading, setContentfulErrorType]);

  if (loading || !article) {
    return null;
  }

  const topicSlug = article.subTopicCollection?.items?.[0]?.slug;
  const articleSlug = article.slug;
  const articleTitle = article.articleTitle;

  return (
    <Link to={`${HELP_ROUTE}/${topicSlug}/${articleSlug}`} className={className} style={style}>
      {articleTitle}
    </Link>
  );
};
